// Card-circuit logos shown next to the "Pay by card" CTA on customer-facing
// checkouts. Inline SVGs keep us off any 3rd-party CDN and avoid CLS.
// Heights kept small (16-18px) so they sit cleanly under the primary button.

const Wrap = ({ children, title }) => (
  <span
    title={title}
    aria-label={title}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      border: '1px solid #E5E7EB',
      borderRadius: 4,
      padding: '2px 4px',
      height: 20,
      boxSizing: 'border-box',
    }}
  >
    {children}
  </span>
);

const VisaLogo = ({ height = 12 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 324" height={height} role="img" aria-label="Visa">
    <path fill="#1A1F71" d="M651.2 0c-69.7 0-132 36.2-132 103 0 76.5 110.4 81.8 110.4 120.2 0 16.2-18.5 30.6-50.1 30.6-44.8 0-78.4-20.2-78.4-20.2l-14.4 67.3s38.6 17.1 90 17.1c76.5 0 136.5-37.9 136.5-105.8 0-80.8-110.9-85.9-110.9-121.5 0-12.7 15.2-26.6 46.7-26.6 35.5 0 64.5 14.7 64.5 14.7L727.4 14S695.2 0 651.2 0zM2.4 4.9L.7 14.7s29.8 5.4 56.7 16.3c34.6 12.5 37 19.7 42.8 42.2L163 312.4h84.4L377.4 4.9h-84.2L209.7 213.9l-34-178.6c-3.1-19.8-18.4-30.4-37.1-30.4H2.4zm408.8 0L345.1 312.4h79.6L490.7 4.9h-79.5zm441 0c-18.7 0-28.5 10-35.5 27.5L693.4 312.4h84.2l16.7-48.3h102.6l9.7 48.3H980L915.3 4.9h-63.1zm9.1 82.7l24.4 121.4h-66.9l42.5-121.4z"/>
  </svg>
);

const MastercardLogo = ({ height = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152 108" height={height} role="img" aria-label="Mastercard">
    <circle cx="56" cy="54" r="48" fill="#EB001B"/>
    <circle cx="96" cy="54" r="48" fill="#F79E1B"/>
    <path fill="#FF5F00" d="M76 19a48 48 0 0 0 0 70 48 48 0 0 0 0-70z"/>
  </svg>
);

const AmexLogo = ({ height = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 64" height={height} role="img" aria-label="American Express">
    <rect width="96" height="64" rx="4" fill="#2E77BC"/>
    <text x="48" y="38" textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontWeight="900" fontSize="13" fill="#fff" letterSpacing="0.5">AMEX</text>
  </svg>
);

/**
 * Inline row of accepted card circuits. Use just below a "Pay by card" CTA.
 *   <CardBrands />
 */
export const CardBrands = ({ className = '' }) => (
  <div
    className={className}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      flexWrap: 'wrap',
    }}
  >
    <span style={{ fontSize: 10, color: '#94A3B8', letterSpacing: 0.3 }}>Pagamenti sicuri</span>
    <Wrap title="Visa"><VisaLogo /></Wrap>
    <Wrap title="Mastercard"><MastercardLogo /></Wrap>
    <Wrap title="American Express"><AmexLogo /></Wrap>
  </div>
);

export default CardBrands;
